import { render, staticRenderFns } from "./HandleDualChallengeSurveyPage.vue?vue&type=template&id=12b77b2f&scoped=true&"
import script from "./HandleDualChallengeSurveyPage.vue?vue&type=script&lang=js&"
export * from "./HandleDualChallengeSurveyPage.vue?vue&type=script&lang=js&"
import style0 from "./HandleDualChallengeSurveyPage.vue?vue&type=style&index=0&id=12b77b2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b77b2f",
  null
  
)

export default component.exports